module.exports = __webpack_public_path__ + "static/media/goatpy_logo.eba1b816.png";